(function () {
  const COLLECTION_KEY = 'sb_last_collection';
  const FROM_COLLECTION_KEY = 'sb_from_collection';

  const templateName = window.__SB_TEMPLATE_NAME__;

  /* ========= DOM helpers ========= */

  function showCollectionBreadcrumb(collection,onlyShow) {
    const node = document.getElementById('breadcrumb-collection-node');
    const link = document.getElementById('breadcrumb-collection-link');
    const text = document.getElementById('breadcrumb-collection-text');
    if(onlyShow) {
     return  node.style.display = 'block';
    }

    if (!node || !link || !text) return;

    link.href = collection.url;
    text.textContent = collection.title;
    node.style.display = 'block';
  }

  function hideCollectionBreadcrumb() {
    const node = document.getElementById('breadcrumb-collection-node');
    if (node) node.style.display = 'none';
  }

  function isReferrerCollection() {
    try {
      return document.referrer.includes('/collections/');
    } catch (e) {
      return false;
    }
  }

  function getCollectionHandleFromURL() {
    const res = window.location.pathname.match(
      /^\/collections\/([^/]+)\/products\//
    );
    return res;
  }

  /* ========= 1. collection 页 ========= */
  if (templateName === 'collection') {
    const collectionData = window.__SB_COLLECTION__;

    if (collectionData) {
      localStorage.setItem(
        COLLECTION_KEY,
        JSON.stringify(collectionData)
      );

      // 标记为：未消费
      sessionStorage.setItem(FROM_COLLECTION_KEY, '1');
    }

    return;
  }

  /* ========= 2. product 页 ========= */
  if (templateName === 'product') {

    if(getCollectionHandleFromURL()) return showCollectionBreadcrumb(null,true);

    const lastCollectionJson = localStorage.getItem(COLLECTION_KEY);
    const fromFlag = sessionStorage.getItem(FROM_COLLECTION_KEY);
    const fromReferrer = isReferrerCollection();

    // 是否允许显示集合（入口判断）
    const canEnter =
      (fromFlag === '1') || (!fromFlag && fromReferrer);

    if (!canEnter || !lastCollectionJson) {
      hideCollectionBreadcrumb();
      return;
    }

    try {
      const lastCollection = JSON.parse(lastCollectionJson);
      const productCollections = window.__SB_PRODUCT_COLLECTIONS__ || [];

      if (!productCollections.includes(lastCollection.handle)) {
        hideCollectionBreadcrumb();
        sessionStorage.removeItem(FROM_COLLECTION_KEY);
        return;
      }

      // ✅ 第一次 product 消费集合
      showCollectionBreadcrumb(lastCollection);

      // 🔥 标记为已消费（关键）
      sessionStorage.setItem(FROM_COLLECTION_KEY, 'used');

    } catch (e) {
      hideCollectionBreadcrumb();
      sessionStorage.removeItem(FROM_COLLECTION_KEY);
    }

    return;
  }

  /* ========= 3. 其他页面 ========= */
  sessionStorage.removeItem(FROM_COLLECTION_KEY);
})();
